<template>
  <modal name="display-welcome" classes="am-vue-modal-responsive-screen" width="50%" height="auto" :adaptive="true" :clickToClose="false" :scrollable="true" :minHeight="500">
    <welcome></welcome>
  </modal>
</template>

<script>
import Welcome from './Welcome'
export default {
  name: 'WelcomeModal',
  components: {
    welcome: Welcome
  },
  mounted () {
    this.$modal.show('display-welcome')
  }
}
</script>

<style scoped>
  .v--modal-overlay {
    background-color: rgba(0,0,0,0.6);
  }
</style>
